module.exports = __webpack_public_path__ + "static/media/vimmerby.c25d6e9d.jpeg";